import React from 'react';

export function textWithLineBreaks(text: string): React.ReactNode {
    try {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    } catch (error) {
        console.error('Error in textWithLineBreaks.tsx - textWithLineBreaks:', error);
        return text;
    }
}
